import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {CalibrationData} from "./calibrationStatus";
import {stringify} from "@angular/compiler/src/util";
import {numberSymbols} from "@progress/kendo-angular-intl";

@Injectable({
  providedIn: 'root'
})
export class Calibrationdataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<CalibrationData> {
    this.uiUrl = this.url.GetAiCalibrationStatusUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<CalibrationData>(this.uiUrl);
  }

}

